module.exports = __webpack_public_path__ + "img/new1-2.1f925b93.png";